import { useRouter } from 'next/router';
import qs from 'qs';
import { isMobile } from '@zep/utils';
import { SubscribePlan } from '../../../../types';
import { OnetimePeriod, PlanTemplateType, SubscriptionPeriod } from '../../plan-payment';
export const useGoSubscriptionPayment = () => {
  const router = useRouter();
  return ({
    planType,
    spaceHashId,
    planTemplateType,
    onetimePeriod,
    subscriptionPeriod
  }: Payload) => {
    const queryString = qs.stringify({
      planType,
      spaceHashId,
      planTemplateType,
      onetimePeriod,
      subscriptionPeriod,
      ...router.query
    });
    if (isMobile()) {
      router.push(`/plan-payment?${queryString}`);
      return;
    }
    window.open(`/plan-payment?${queryString}`);
  };
};
type Payload = {
  // 선택 없으면 베이스값 선택이 됩니다
  planType?: SubscribePlan;
  planTemplateType?: PlanTemplateType.PRODUCT_SUBSCRIPTION | PlanTemplateType.PRODUCT_ONETIME;
  subscriptionPeriod?: SubscriptionPeriod;
  onetimePeriod?: OnetimePeriod;
  spaceHashId: string;
};